import { render, staticRenderFns } from "./AppointmentTabs.vue?vue&type=template&id=1f5ae583"
import script from "./AppointmentTabs.vue?vue&type=script&lang=js"
export * from "./AppointmentTabs.vue?vue&type=script&lang=js"
import style0 from "./AppointmentTabs.vue?vue&type=style&index=0&id=1f5ae583&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports